import { buildQueryString } from 'lib/utils/utils.js';
import { httpService } from './http.service.js';

const ENDPOINT = 'org';

export const orgService = {
  getAllOrgs,
  getOrg,
  getOrgList,
  getAllOrgNames,
  getRootOrgs,
  getOrgActivitiesById,
  getInheritedRegulations,
  getOrgHierarchy,
  unarchive,
  addRootOrg,
  save,
  remove,
  generateSuggestedActivities
};

async function getAllOrgs() {
  return await httpService.get(`${ENDPOINT}/all/list`);
}

async function getAllOrgNames() {
  return await httpService.get(`${ENDPOINT}/all/names`);
}

async function getOrg(_id) {
  return await httpService.get(`${ENDPOINT}/${_id}`);
}

async function getOrgList(_id, queryOpts = {}) {
  const queryStr = buildQueryString(queryOpts);
  return await httpService.get(`${ENDPOINT}/list/${_id}${queryStr}`);
}

async function getRootOrgs() {
  return await httpService.get(`${ENDPOINT}/root/list`);
}

async function getOrgActivitiesById(_id, type = 'actions') {
  return await httpService.get(`${ENDPOINT}/${_id}/activities/${type}`);
}

async function getInheritedRegulations(_id) {
  return await httpService.get(`${ENDPOINT}/${_id}/inherited-regulations`);
}
async function getOrgHierarchy(_id) {
  return await httpService.get(`${ENDPOINT}/${_id}/hierarchy`);
}

async function addRootOrg(org) {
  return await httpService.post(`${ENDPOINT}/root`, org);
}

async function unarchive(_id) {
  return await httpService.post(`${ENDPOINT}/${_id}/unarchive`);
}

async function save(org) {
  if (org._id) {
    return await httpService.put(`${ENDPOINT}/${org._id}`, org);
  }
  return await httpService.post(`${ENDPOINT}`, org);
}

async function generateSuggestedActivities(data) {
  return await httpService.put(`${ENDPOINT}/generate-suggested-activities`, data);
}

async function remove(_id) {
  return await httpService.delete(`${ENDPOINT}/${_id}`);
}
